'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var React = require('react');
var NoStyleButton_web = require('../../atoms/NoStyleButton/NoStyleButton.web.cjs');
var Skeleton_web = require('../../atoms/Skeleton/Skeleton.web.cjs');
var Typography_web = require('../../atoms/Typography/Typography.web.cjs');
var DropdownMenu_web = require('../../molecules/DropdownMenu/DropdownMenu.web.cjs');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var AvailabilityStatusPill_web = require('../AvailabilityStatusPill/AvailabilityStatusPill.web.cjs');
var VariantDropdown_web_styles = require('./VariantDropdown.web.styles.cjs');

/**
 * A dropdown that displays variants and availability status of a product.
 *
 * @scope Web
 */ const VariantDropdown = ({ currentVariantId, onVariantSelect, variants, isContentLoading, onOpen })=>{
    const [isOpen, setIsOpen] = React.useState(false);
    const currentTheme = react.useTheme();
    const currentVariant = variants.find((variant)=>variant.id === currentVariantId) || variants[0];
    const sortedVariants = [
        ...variants
    ].sort((a, b)=>a.msrp - b.msrp);
    const availabilityPill = (status, tooltip)=>/*#__PURE__*/ jsxRuntime.jsx(AvailabilityStatusPill_web.AvailabilityStatusPill, {
            tooltipContent: tooltip,
            availabilityStatus: status,
            size: "small",
            pillStyles: VariantDropdown_web_styles.pill
        });
    if (variants.length === 1) {
        return /*#__PURE__*/ jsxRuntime.jsxs("div", {
            css: VariantDropdown_web_styles.wrapper,
            children: [
                /*#__PURE__*/ jsxRuntime.jsx("span", {
                    children: /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                        isMarginless: true,
                        variant: "footnote",
                        children: variants[0].descriptor
                    })
                }),
                availabilityPill(variants[0].availabilityStatus, variants[0].availabilityStatusTooltipContent)
            ]
        });
    }
    const handleDropdownToggle = ()=>{
        if (!isOpen) {
            onOpen?.();
        }
        setIsOpen(!isOpen);
    };
    const renderDropdownContent = ()=>{
        if (isContentLoading) {
            return /*#__PURE__*/ jsxRuntime.jsxs("div", {
                css: VariantDropdown_web_styles.variantsLoading,
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
                        variant: "typography",
                        width: "100%"
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
                        variant: "typography",
                        width: "100%"
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
                        variant: "typography",
                        width: "100%"
                    })
                ]
            });
        }
        return /*#__PURE__*/ jsxRuntime.jsx(DropdownMenu_web.DropdownMenu.RadioGroup, {
            value: currentVariant.descriptor,
            children: sortedVariants.map(({ id, descriptor, availabilityStatus })=>/*#__PURE__*/ jsxRuntime.jsx(DropdownMenu_web.DropdownMenu.RadioItem, {
                    onSelect: ()=>onVariantSelect(id),
                    value: descriptor,
                    children: /*#__PURE__*/ jsxRuntime.jsxs("div", {
                        css: VariantDropdown_web_styles.item,
                        children: [
                            /*#__PURE__*/ jsxRuntime.jsx("span", {
                                children: descriptor
                            }),
                            availabilityPill(availabilityStatus, "")
                        ]
                    })
                }, id))
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: VariantDropdown_web_styles.wrapper,
        children: [
            /*#__PURE__*/ jsxRuntime.jsxs(DropdownMenu_web.DropdownMenu, {
                isOpen: isOpen,
                onOpenChange: handleDropdownToggle,
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx(DropdownMenu_web.DropdownMenu.Trigger, {
                        children: /*#__PURE__*/ jsxRuntime.jsxs(NoStyleButton_web.NoStyleButton, {
                            customCss: VariantDropdown_web_styles.trigger,
                            children: [
                                /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                                    variant: "footnote",
                                    isMarginless: true,
                                    children: currentVariant.descriptor
                                }),
                                /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                                    icon: isOpen ? index.faAngleUp : index.faAngleDown,
                                    color: currentTheme.ds5.dropdown.neutral.textBody
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx(DropdownMenu_web.DropdownMenu.Content, {
                        align: "start",
                        children: renderDropdownContent()
                    })
                ]
            }),
            availabilityPill(currentVariant.availabilityStatus, currentVariant.availabilityStatusTooltipContent)
        ]
    });
};

exports.VariantDropdown = VariantDropdown;
//# sourceMappingURL=VariantDropdown.web.cjs.map
